type valueType = string | number | boolean | undefined;
type filerStringFn = (...args: any) => string;
type filerStringFnGroup = (
  key: string
) => Record<string, (value: valueType) => string>;

const contains: filerStringFn = (key: string, value: valueType): string =>
  `contains(${key},'${value}')`;

const cast: filerStringFn = (
  key: string,
  type: "Edm.String" = "Edm.String"
): string => `CAST(${key},'${type}')`;

const compareFn =
  (
    key: string,
    operation: "eq" | "ne" | "gt" | "lt" | "in" | "ge" | "le" = "eq",
    addQuotes = false
  ) =>
  (value: valueType): string => {
    const _value =
      typeof value === "string" && addQuotes ? `'${value}'` : value;
    return `${key} ${operation} ${_value}`;
  };

export const compare: filerStringFnGroup = (key: string) => ({
  eq: compareFn(key, "eq", true),
  ne: compareFn(key, "ne", true),
  gt: compareFn(key, "gt"),
  gte: compareFn(key, "ge"),
  lt: compareFn(key, "lt"),
  lte: compareFn(key, "le"),
  in: compareFn(key, "in"),
});

const documentLineTemplate = (value: string) =>
  `DocumentLines/any(DocumentLine: ${value})`;

const documentLine: filerStringFnGroup = (key: string) => ({
  in: (value: valueType): string =>
    documentLineTemplate(compare(`DocumentLine/${key}`).in(value)),
  contains: (value: valueType): string =>
    documentLineTemplate(contains(`DocumentLine/${key}`, value)),
});

export default { contains, cast, compare, documentLine };
